export default __webpack_public_path__ + "static/media/real_estate_web-sm@2x.6921fe70.jpg";